import { Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { useNotificationStore } from '@/stores/notification-store';
import { analyticsNotificationClicked } from '@/lib/analytics-service';
import {
  Button,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@scio3/ui';
import dayjs from 'dayjs';

export function NotificationDropdown() {
  const { t } = useTranslation();
  const { notifications, unreadCount, markRead } = useNotificationStore();

  return (
    <DropdownMenu>
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="icon-sm"
                className="relative text-muted-foreground hover:text-foreground hover:bg-sidebar-active/60"
                aria-label={t('Notifications')}
              >
                <Bell className="h-5 w-5" />
                {unreadCount > 0 && (
                  <span className="absolute -right-0.5 -top-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-destructive text-[10px] font-bold text-destructive-foreground">
                    {unreadCount}
                  </span>
                )}
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent side="bottom">{t('Notifications')}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <DropdownMenuContent align="end" className="max-h-96 w-80 overflow-y-auto">
        {notifications.length === 0 ? (
          <div className="p-4 text-center text-sm text-muted-foreground">
            {t('No notifications')}
          </div>
        ) : (
          notifications.map((notification) => (
            <div
              key={notification._id}
              className={cn(
                'cursor-pointer border-b p-3 hover:bg-accent',
                !notification.read && 'bg-primary/5',
              )}
              onClick={() => {
                analyticsNotificationClicked({
                  notificationType: notification.type ?? 'unknown',
                });
                markRead(notification._id);
              }}
            >
              <p className="text-sm">{notification.message}</p>
              <p className="mt-1 text-xs text-muted-foreground">
                {dayjs(notification.createdAt).format('MM/DD/YYYY')}
              </p>
            </div>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
